import { Injectable } from '@angular/core';
import { FieldDictionaryListService } from './field-dictionary-list.service';
import { Subject, takeUntil } from 'rxjs';
import { FormValidationService } from '../validation/form-validation/form-validation.service';
import { AsyncValidatorFn, FormGroup } from '@angular/forms';
import { FieldDictionaryDto } from '../../models/base/base';

@Injectable({
  providedIn: 'root'
})
export class DynamicSetFormValidatorsService {

  constructor(
    private fieldDictionaryListService: FieldDictionaryListService,
    private formValidation: FormValidationService
  ) { }

  setValidators(form: FormGroup, systemMenuId: string, destroy$: Subject<void>, applyDuplicate: boolean = true): void {
    let pageFields
    this.fieldDictionaryListService.getList().pipe(takeUntil(destroy$)).subscribe({
      next: (res) => {
        if (res) {
          const pageData = res.find((x) => x.pageid == systemMenuId);
          if (!pageData) return
          // pageFields = pageData.list;
          pageFields = pageData.list.map(item => ({
            ...item,
            fieldname: item.fieldname.includes('.')
              ? item.fieldname.split('.').pop()
              : item.fieldname  // remove table name . from fieldname
          }));
          // console.log('pageFields', pageFields);

          if (pageFields && form) {
            // console.log('pageFields', pageFields, this.form.controls);
            Object.keys(form.controls).forEach((control) => {
              // console.log('control', control);
              const field: FieldDictionaryDto = pageFields.find((x) => (x.fieldname).toLowerCase() === control.toLowerCase());
              // console.log('field', field);
              if (field) {
                const validators = [];
                const asyncValidators: AsyncValidatorFn[] = [];
                // if (field.required) { //&& field.fieldType !== 'bit'
                //   // console.log('field', field.fieldName, field.required);
                //   // debugger
                //   validators.push(FormValidationService.required());
                // }
                if (field.required) {
                    if (Array.isArray(form.get(control)?.value)) {
                        // multi-select required
                        validators.push(FormValidationService.requiredArray());
                    } else {
                        validators.push(FormValidationService.required());
                    }
                }
                if (field.minvalue) {
                  validators.push(FormValidationService.min(field.minvalue, field.fieldtype));
                }
                if (field.maxvalue) {
                  validators.push(FormValidationService.max(field.maxvalue, field.fieldtype));
                }
                if (field.precision) {
                  validators.push(FormValidationService.precision(field.precision));
                }
                if (field.stopduplicate && applyDuplicate) {
                  //debugger
                  asyncValidators.push(this.formValidation.stopDuplicate(field.fieldname, field.tablename, field.parameter));
                }
                if (field.fieldname.toLowerCase().endsWith('email')) {
                  validators.push(FormValidationService.email());
                }
                if (field.fieldname === 'phonenumber' || field.fieldname.toLowerCase().includes('mobile') || field.fieldname.toLowerCase().endsWith('phone')) {
                  validators.push(FormValidationService.phone());
                }
                if (field.fieldtype === '') {
                  validators.push(FormValidationService.pattern());
                }
                //update form control validators

                form.get(control)?.setValidators(validators);
                form.get(control)?.setAsyncValidators(asyncValidators);
                form.get(control)?.updateValueAndValidity();
              }
            })
          }
          // console.log('setValidators', this.form);
        }
      }
    });

  }

}
